import classNames from 'classnames'
import React from 'react'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'

export default ({ classes, sponsor, campaignId, isMobileRes }) => {
	const sponsorName = campaignId === 'bb43bd9c-3cde-4751-8b57-0a00278a0fc9'
		? 'Systemic Reaction'
		: sponsor.brandName
	const logoUrl = campaignId === 'bb43bd9c-3cde-4751-8b57-0a00278a0fc9'
		? 'daredrop.com/files/Systemic_Reaction_Vert_Endorsed_RGB_White_small.png'
		: sponsor.brandLogo.small

	return (
		<div className={classNames(classes.brandWrapper, 'layout-row', 'layout-align-end')}>
			{!isMobileRes && <div className={classNames(classes.brand)} />}
			<div className={classNames(classes.brandContainer)}>
				<span className={classes.detailsText}>Sponsored By</span>
				<div className={classNames(classes.brand)}>
					<img
						alt={sponsorName}
						src={addHttpsProtocol(logoUrl)}
						className={classes.brandLogo}
					/>
				</div>
			</div>
		</div>
	)
}
